<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Insurances Info'"            
            v-bind:titleRef="'titleElementInsurance'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ut eleifend massa. Nam ut pulvinar velit. In volutpat, ligula ac consequat dapibus, libero est accumsan massa, et laoreet odio augue non tortor.
        </p>

          <b-row>           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Transaction Type'"
                        v-bind:Options="TransactionList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Transaction"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownTransaction"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Status'"
                        v-bind:Options="StatusList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Status"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownStatus"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Category'"
                        v-bind:Options="CategoryList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Category"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCategory"/>
            </b-col>
               
        </b-row>

         <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

          <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('claimbatchList.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group">
                          <input 
                            type="text" 
                            class="form-control"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
                  
          
                                     
              </div>
          </div>

         
        <MdTablePaginationClient 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage" 
            v-bind:SelectAll="UseSelectTableAll"             
            v-bind:pageOptions="pageOptions"
            :iconSelected="IconSelected"
            :editIconEvent="EditPrior"
            :onFiltered="onFiltered"               
            v-bind:VisibleEditIcon="true"                        
            :onRowSelected="onRowSelected"    
            :pageChanged="pageChanged"
            :RowClick="RowClicked"        
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>


        <IniModalEditPriorAutho 
            v-if="showModalEditPriorAutho"
            v-bind:InsuranceCode="InsuCode"
            v-bind:GoalEdit="{}"
            @OnResetModal="Reset($event)"
            v-bind:ModalId="'iModalIdEditPriorAutho'" 
            v-bind:TitleWindow="'Edit Insurance'"            
        />

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"           
            v-bind:Name="'btnInsuranceBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnInsuranceNext'"
            v-bind:ClassProp="'mx-2'"/>  

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-on:click="UpdateSelectedInsu()"
            v-bind:Name="'btnInsurance'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>
import { EventBus } from '@/event-bus.js';
import ISetup from '@/services/isetup.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'

export default {
  name: 'IniInsurance',
   mixins: [ShowMessage, DBFunctions], 
  data(){
    return{
        TransactionList:[            
            {code:"A",description:"Institutional Claim (Part A)"},
            {code:"B",description:"Professional Claim (Part B)"},
            {code:"",description:"All"}
        ],
        Transaction:{code:"",description:"All"},
        showModalEditPriorAutho:false,
        parameter:{
            SearchCriteria:"",
            PageNumber : 0,
            PageSize:0,
        },
        ShowMessageIsEmpty:false,
        items:[],
        Status:{code:null,description:"All"},
        StatusList:[
            {code:true,description:"Selected"},
            {code:false,description:"No Selected"},
            {code:null,description:"All"}
        ],
        Category:{code:"",description:"All"},
        CategoryList:[
            {code:"MA",description:"Medicare Part A"},
            {code:"MB",description:"Medicare Part B"},
            {code:"MC",description:"Medicaid"},
            {code:"CI",description:"Commercial Insurance Co."},
            {code:"BL",description:"Blue Cross/Blue Shield"},
            {code:"",description:"All"}
        ],
        InsuCode:"",
        fields:[
            { key: 'payerName', sortable: true, label: 'Payer Name', class: 'text-rigth' },         
            { key: 'insuranceCode', sortable: true, label: '', class: 'text-rigth hidden' },  
            { key: 'transactionType', sortable: true, label: 'Transaction Type', class: 'text-rigth' },
            { key: 'payerId', sortable: true, label: 'Payer Id', class: 'text-rigth' },
            { key: 'indicatorDescription', sortable: true, label: 'Category', class: 'text-rigth' },
            { key: 'enrollmentRequiredTranslated', sortable: true, label: 'Enrollment Required', class: 'text-rigth' },
            { key: 'userPriorAuthorizationTranslated', sortable: true, label: 'User PriorAuthorization', class: 'text-rigth' },
            { key: 'priorAuthorizationBasedOn', sortable: true, label: 'Prior Authorization Based On', class: 'text-rigth' },
            { key: 'useDateRangeForPriorAuthorizationTranslated', sortable: true, label: 'Use DateRange For PriorAuthorization', class: 'text-rigth' },
            { key: 'UseUnitsAs', sortable: true, label: 'Use Units As', class: 'text-rigth' },
            { key: 'warnMeDayBeforeEndDate', sortable: true, label: 'Warn Me Day Before EndDate', class: 'text-rigth' },   
            { key: 'warnMeUnitsBeforeEndDate', sortable: true, label: 'Warn Me Units Before EndDate', class: 'text-rigth' },                      
        ],
        indexSelected : 0,
        SelectedRecords:0,
        UseSelectTableAll:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        modelSearch:"",

    }
  },
  methods:{

    ChangeDropDownTransaction(item){
        this.Transaction = item;
        this.getInsuranceList();

    },

    onFiltered(){

    },

    Reset(){
        this.showModalEditPriorAutho = false;
        this.getInsuranceList();
    },

    IconSelected(){

    },

    RowClicked(item,index,event){
        this.indexSelected = index;     
    if(event.target.getAttribute('btn') === null){
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }
        EventBus.$emit('rowClicked', item);
    }        
    },

    FindinItems(){

    },

    ChangeDropDownStatus(item){
        this.Status = item;
        this.getInsuranceList();
    },

    ChangeDropDownCategory(item){
        this.Category = item;
        this.getInsuranceList();
    },

    EditPrior(item){
        this.InsuCode = item.insuranceCode;
        this.showModalEditPriorAutho = true;
    },

    async getInsuranceList(){   
      this.$emit('load', true);  
      let param = {
        TransactionType:this.Transaction.code,
        Selected:this.Status.code,
        Category:this.Category.code
      } 
      await ISetup.getAllIsurances(param)
      .then((response) => {      
           if (response.status == "200") {              
                this.items = response.data;  
                let count = 0;
                this.items.forEach(element => {
                    if(element.transactionType === "1"){
                        element.transactionType = "";
                    }
                    if(element.selected){
                        count++;
                    }
                });

                this.SelectedRecords = count;

                this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;
                this.totalRows = this.items.length;            
                this.$emit('load', false);
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },


    getSelection(){
        let arr = [];

        this.items.forEach(element => {
            arr.push({InsuranceCode:element.insuranceCode,Selected:element.selected});
        });

        return arr;
    },

    async UpdateSelectedInsu(){   
      this.$emit('load', true);

      await ISetup.UpdateSelectedInsurance(this.getSelection())
      .then((response) => {      
           if (response.status == "200") { 
              this.$emit('load', false);            
           }
          this.$emit('load', false);  
      })
      .catch(error => {
        this.$emit('load', false);  
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },    

     onChangeSelectAll(v){
        if(v){
        this.SelectedRecords = this.items.length; 
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true); 
        }
      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false); 
        }
      }
    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
      //  this.SearchAppTypes();   
    },

    pageChanged(page){
        this.currentPage = page;    
       // this.SearchAppTypes();   
    },

    SelectAllRecords(){
      this.SelectedPage = this.items.length;
      this.wasSelectedAll = true;
    },

     onRowSelected(){ 
     this.SelectedRecords = 0;
     if(this.items.length > 0){
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }
     }
    },
    
    Next(){
       // this.$router.push({ name:'iprograms'});
    },

    Back(){
     //   this.$router.push({ name:'iusers'}); 
    }
  },
  created(){
    this.getInsuranceList();
     EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.items.length; i++){
                if(this.items[i].selected){
                    this.SelectedRecords++;
                }
            }      
     }.bind(this));
  },
  mounted(){

  }   
};
</script>


